import { Col, Divider, Row, Typography } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import AdminProfile from '../components/account/admin-profile';
import ChangePasswordForm from '../components/account/change-password-form';
import ProfileForm from '../components/account/profile-form';
import AdminAuthLogTable from '../components/admin-auth-log-table';
import AdminSessionsTable from '../components/admin-sessions-table';
import DetailPageHeader from '../components/detail-page-header';
import { type RootState } from '../reducers';
import { SPACING } from '../theme/tokens';

const { Text } = Typography;

function AccountContainer(): React.ReactElement {
  const { accountUUID } = useParams<{ accountUUID: string }>();
  const userEmail = useSelector((s: RootState) => s.User.email);
  const userUuid = useSelector((s: RootState) => s.User.uuid);
  const userUsername = useSelector((s: RootState) => s.User.username);

  if (accountUUID && accountUUID !== userUuid) {
    return <AdminProfile accountUUID={accountUUID} />;
  }

  return (
    <>
      <DetailPageHeader
        title="Account"
        info={<Text type="secondary">{userUsername ?? userEmail}</Text>}
      />

      <Row gutter={[SPACING.lg, SPACING.lg]}>
        <Col xs={24} lg={12} xxl={8}>
          <ProfileForm />
        </Col>
        <Col xs={24} lg={12} xxl={8}>
          <ChangePasswordForm />
        </Col>
      </Row>

      <Divider />

      <AdminSessionsTable />

      <Divider />

      <AdminAuthLogTable />
    </>
  );
}

export default AccountContainer;
